module.exports = __webpack_public_path__ + "static/img/athome_facial2.a86c353.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/athome_facial2.jpeg
// module id = 749
// module chunks = 1